import type { ReactElement, ReactNode } from 'react';

import { ApiClientError } from '@/shared/api';
import { Icon } from '@/shared/ui/icon';

import { Button } from '../button';
import styles from './State.module.scss';

export function LoadingState({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className={styles.state} role="status">
      <span className={styles.spinner} aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className={styles.state}>
      <span className={styles.illustration} aria-hidden="true">
        <Icon name="catalog" />
      </span>
      <p className={styles.title}>{title}</p>
      {children}
    </div>
  );
}

export function NoResults({ onReset }: { onReset: () => void }): ReactElement {
  return (
    <div className={styles.state}>
      <span className={styles.illustration} aria-hidden="true">
        <Icon name="search" />
      </span>
      <p className={styles.title}>Ничего не найдено</p>
      <p className={styles.meta}>Измените запрос или сбросьте фильтры.</p>
      <Button variant="secondary" onClick={onReset}>
        Сбросить фильтры
      </Button>
    </div>
  );
}

/** A failed load with a retry and the request id support can look up. */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message = error instanceof ApiClientError ? error.message : 'Не удалось загрузить данные';
  const requestId = error instanceof ApiClientError ? error.requestId : null;
  return (
    <div className={styles.state} role="alert">
      <p className={styles.title}>{message}</p>
      {requestId && <p className={styles.meta}>Код запроса: {requestId}</p>}
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Повторить
        </Button>
      )}
    </div>
  );
}
